'use strict';

/* globals define, config */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/board/note-comments-modal', [
	config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/vue.js',
	config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/interact.js',
	'translator',
	'benchpress',
	'boardApp',
], function () {
	var	NoteComments = {};

	NoteComments.init = function () {

	};

	return NoteComments;
});
